/*
  Used to mapping the activeFilters to be queryParamFilters (in Array)
  examples:
  queryParamFilters = [
    "created_on lte 2023-08-29T17:00:00Z",
    "created_on gte 2023-08-29T17:00:00Z",
    "status.name eq 'DRAFT'",
  ]
*/

const queryFiltersMappings = {
  gte: (key, value) => {
    return `${key.replace(/:gte/g, '')} gte ${value}`
  },
  lte: (key, value) => {
    return `${key.replace(/:lte/g, '')} lte ${value}`
  }
}

const filterMappings = {
  'transaction_date:gte': queryFiltersMappings.gte,
  'transaction_date:lte': queryFiltersMappings.lte
}

export default filterMappings